/**
 * QR1 · 凭证 QR 客户评分/投诉页（公开·无 auth）
 * 契约源：apps/api-server/src/api_server/routes/public_review.py
 * 全部 noAuth（不带 token / 不带 X-Tenant-Slug·后端按 token 解析订单+租户）。
 */
import { api } from "./api";

export interface ReviewContext {
  order_no: string;
  customer_name: string;
  driver_name: string | null;
  product_name: string | null;
  travel_date: string | null;
  review_submitted: boolean;
  categories: { value: string; label: string }[];
}

/** GET /api/public/review/{token} — 最小上下文（零敏感） */
export function getReviewContext(token: string): Promise<ReviewContext> {
  return api<ReviewContext>(`/api/public/review/${token}`, { noAuth: true });
}

/** POST /api/public/review/{token}/complaint — 行程中投诉（可多次） */
export function submitComplaint(token: string, category: string, content: string): Promise<{ id: string; ok: boolean }> {
  return api(`/api/public/review/${token}/complaint`, {
    method: "POST",
    noAuth: true,
    body: JSON.stringify({ category, content: content || null }),
  });
}

/** POST /api/public/review/{token}/rating — 行程末评分（一次·已评 409） */
export function submitRating(token: string, rating: number, comment: string): Promise<{ ok: boolean; rating: number }> {
  return api(`/api/public/review/${token}/rating`, {
    method: "POST",
    noAuth: true,
    body: JSON.stringify({ rating, comment: comment || null }),
  });
}
